import React, { useState, useEffect, Component } from 'react';
// import { LinkedIn } from 'react-linkedin-login-oauth2';
// import LinkedIn from "linkedin-login-for-react";
import Link from 'next/link';
import { useRouter } from 'next/router';
import { initiateLogin } from "../../../api/auth";
import { AuthSuccess } from "../../../store/actions/auth";
import { useDispatch, useStore } from "react-redux";
import Facebook from '../../common/scoialLogins/facebook';
import Google from '../../common/scoialLogins/google';
import { connect } from 'react-redux';
import Apple from '../../common/scoialLogins/apple';
import Store from '../../../store';

// import "./style.scss"
// import { getThinkificUrl } from '../../../api/thinkificUrl';


class LoginContent extends Component {
	constructor(props) {
		super(props);

		this.state = {
			email: '',
			password: '',
			showPassword: false,
			passwordValid: true,
			emailValid: '',
			isChecked: false,
			showForgotPassword: false,
			loading: false,
			source: null,
			showLoginForm: false,
			thinkificUrl:null
		}
	}
	// const router = useRouter();
	// const dispatch = useDispatch();
	// const [showLoginForm, setShowLoginForm] = useState(false);

	// const [loginForm, setLoginForm] = useState({
	// 	email: '',
	// 	password: '',
	// 	showPassword: false,
	// 	emailValid: '',
	// 	isChecked: false,
	// 	showForgotPassword: false,
	// 	loading: false,
	// 	source: null,
	// });

	// componentDidUpdate(prevProps) {
	// 	if (Object.keys(this.state.email).length > 0) {
	// 		this.validate('email');
	// 	}
	// 	if (Object.keys(this.state.password).length > 0) {
	// 		this.validate('password');
	// 	}
	// }

	// componentDidMount() {
	// 	getThinkificUrl().then((res)=>{
	// 	this.setState({ thinkificUrl:res  });
	// 		console.log('url//////////',this.state.thinkificUrl)
	// 	})
	// }

	// useEffect(() => {
	// 	if (Object.keys(loginForm.email).length > 0) {
	// 		validate('email');
	// 	} 
	// 	if (Object.keys(loginForm.password).length > 0) {
	// 		validate('password');
	// 	}
	// }, [loginForm.email, loginForm.password]);

	updateField = (field, val) => {
		this.setState({ ...this.state, [field]: val }, () => this.validate(field));
	}

	validate = (field) => {
		let regex, valid;
		let value = this.state[field];
		let _this = this;
		switch (field) {
			case 'email':
				regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
				_this.setState({ ..._this.state, [field + "Valid"]: regex.test(value) });
				break;
			case 'password':
				regex = /^(?=[^\d_].*?\d)\w(\w|[!@#$%*]){7,20}/;
				_this.setState({ ..._this.state, [field + "Valid"]: regex.test(value) });
				break;
		}
	}

	onChangeCheckbox = event => {
		this.setState({
			...this.state,
			isChecked: event.target.checked
		})
	}

	validateForm = () =>{
		const { emailValid } = this.state;
		return (!!emailValid && !this.state.loading);
	}

	login = () => {
		if (!this.state.password) {
			this.setState({ ...this.state, passwordValid: false});
			return;
		}
		const { dispatch } = this.props;   
		if (this.validateForm()) {
			this.setState({ ...this.state, loading: true });
			
			let data = {
				email: this.state.email,
				password: this.state.password,
				remember_token: this.state.isChecked,
			}

			
			initiateLogin(data).then((res) => {
					if (Object.keys(res).length > 0) {
						dispatch(AuthSuccess({ user: res.user_data, token: res.auth_token, profile: res.user_data?.profile }));
						if(res?.user_data?.is_kajabi_user){
							if(res.user_data.new_kajabi_user) {
								this.props.routerObj.push('/forgot-password', "/forgot-password", { shallow: true });
							} else {
								if(res.user_data.form_step != 7){
									this.props.routerObj.push('/register/select-gender', "/select-gender", { shallow: true });
								}else{
									this.props.routerObj.push('/classes', "/classes", { shallow: true });
								}
								// dispatch(AuthSuccess({ user: res.user_data, token: res.auth_token, profile: res.user_data?.profile }));
							}
						} else {
							// if (res.user_data?.is_verified) {
							// 	this.props.routerObj.push('/home', "/home", { shallow: true });
							// } else {
							// 	this.props.routerObj.push('/register/select-gender', "/select-gender", { shallow: true });
							// }
							this.props.routerObj.push('/home', "/home", { shallow: true });
							// dispatch(AuthSuccess({ user: res.user_data, token: res.auth_token, profile: res.user_data?.profile }));
						}
					}
					this.setState({ ...this.state, loading: false });
				});
			

		}
	}

	setBackUrl = (e) => {
		e.preventDefault();
		if(this.props.routerObj.back()) {
			this.props.routerObj.back()
		}
		else {
			this.props.routerObj.push('/', { shallow: true });
		}
	} 

	componentDidMount(){
		const { userAuth } = Store.getState();
		if (userAuth.token) {
			window.location.href = '/home';
		}
	}

render () {
	
	return (
	<div className="login-page">
		<div className="login-wrapper">
			{/* {this.state.showLoginForm ?  */}
			
			<div className="box">
				<img src={`${process.env.IMAGES_BASE_URL}/static-content/Login-logo.png.webp`} alt="Login Page Logo" width="200" />
					<div onClick={this.setBackUrl}><span className="back"></span><p id="text">Back</p></div>
					{/* <span onClick={() => this.setState({ ...this.state, showLoginForm: false })} className="back"></span> */}
				<h1>Log In</h1>
				<div className="inner-box">
					<div className="field">
						<label>Email address</label>
						<input id="_email" name="email" type="email" className={"is-input email-field " + (this.state.emailValid === false ? 'input-err' : this.state.emailValid === true ? 'input-valid' : '')}
							placeholder="Email" value={this.state.email || ''} onChange={(e) => this.updateField('email', e.target.value)} />
						{this.state.emailValid === false && <small className='err-msg'>*Must enter a valid Email.</small>}
					</div>

					<div className="password-field field">
						<label>Password</label>
						<input id="_password" name="password" type={this.state.showPassword ? "text" : "password"} className={"is-input "}
							placeholder="Password" value={this.state.password || ''} onChange={(e) => this.updateField('password', e.target.value)} />
							<div className="login-show-pass" onClick={() => this.setState({ ...this.state, showPassword: !this.state.showPassword })}>
							{this.state.showPassword ? <i className="fas fa-eye eye"></i> : <i className="fas fa-eye-slash eye"></i>}
						</div>
							{this.state.passwordValid === false && <small className='err-msg'>{"*Must enter a password."}</small>}
					</div>

					<div className="field-check">
						<label className="checkbox-w">Remember me
							<input type="checkbox" checked={this.state.isChecked} name="lsRememberMe" onChange={(e) => this.onChangeCheckbox(e)} />
							<span className="checkmark"></span>
						</label>
					</div>

					<div className={"login-btn " + (this.validateForm() ? '' : 'disabled')} onClick={() => this.login()}>
						Log In
						{this.state.loading && <img src={`/icons/loading.svg`} style={{ height: '25px', marginLeft: '10px' }} />}
					</div>
					<div className="reverse">
						<div className="action">
							<Link href="/register" as="/register">
								<a>Don' t have an account yet ?</a>
							</Link>
							<Link href="/forgot-password" as="/forgot-password">
								<a>Forgot password ?</a>
							</Link>
						</div>


						<div className="login-third-party">
							<div className="login-round-btn"><Facebook /></div>
							<div className="login-round-btn"><Google /></div>
							{/* <div className="login-round-btn apple-login"> */}
								{/* <Apple /> */}
								{/* <img src={`${process.env.IMAGES_BASE_URL}/static-content/apple.png.webp`} alt='apple-logo' /> */}
							{/* </div> */}


							{/* <LinkedIn
								clientId="861q7od3dgmw4q"
								onSuccess={responseLinkedIn}
								className="LinkedIn-button"
								scope={["r_liteprofile", "r_emailaddress"]}
								state="No"
								text="LinkedIn"
							/> */}
							{/* <div className="login-round-btn fb-login" onClick={() => window.location.href = '/facebook?utm_source=SEO&utm_medium=loginPage'}>
								<img src="https://d310ox1f4zno4b.cloudfront.net/static-content/facebook-logo.png.webp" alt='facebook-logo' />
							</div>
							<div className="login-round-btn google-login" onClick={() => window.location.href = '/googleSignin?utm_source=SEO&utm_medium=loginPage'}>
								<img src="https://d310ox1f4zno4b.cloudfront.net/static-content/google-logo.png.webp" alt='google-logo' />
							</div>
							<div className="login-round-btn apple-login" onClick={() => window.location.href = '/appleSignIn?utm_source=SEO&utm_medium=loginPage'}>
								<img src="https://d310ox1f4zno4b.cloudfront.net/static-content/apple-logo.png.webp" alt='apple-logo' />
							</div>
							<div className="login-round-btn linkedin-login" onClick={() => window.location.href = '/linkedinSignin?utm_source=SEO&utm_medium=loginPage'}>
								<img src="https://d310ox1f4zno4b.cloudfront.net/static-content/linkedin-logo.png.webp" alt='linkedin-logo' />
							</div> */}
						</div>
					</div>
				</div>
			</div>
			{/* :  */}
			{/* 	<div className="box white-login">
					<img className="v-lgo" src={`${process.env.IMAGES_BASE_URL}/static-content/Login-logo.png.webp`} alt="Login Page Logo" width="200" />
					<h1>Where would you like to login to?</h1>
					<div className="inner-box">
						<div className="field">
							<a target="_blank" href="https://www.bayanonline.org/login?offer_token=LtXd2L9g">
								<span> */}
								{/* <img src={`${process.env.IMAGES_BASE_URL}/static-content/bayanBigLogo.png.webp`} alt="Bayan On-Demand site" width="200"/> */}
								{/* <img src="/icons/bayan-online.png" width="180"/>
								</span>
							</a>
						</div>

						<div className="password-field field">
								<span onClick={() => this.setState({ ...this.state, showLoginForm: true })}>*/}
								{/* <img src={`${process.env.IMAGES_BASE_URL}/static-content/bayanBigLogo.png.webp`} alt="Bayan community site" width="200" /> */}
								{/* <img src="/icons/bayan-community.png" width="180" />
							</span>
						</div>

					</div>
				</div>
			}  */}
			
		</div>
	</div>
	);
}
};
export default connect(null, null)(LoginContent);
// export default LoginContent;
